import { apiFetch } from './api';

/**
 * List all translation requests (admin)
 */
export function listTranslationRequests(params = {}) {
  const queryParams = new URLSearchParams();
  if (params.status) queryParams.append('status', params.status);
  if (params.search) queryParams.append('search', params.search);
  if (params.page) queryParams.append('page', params.page);
  if (params.limit) queryParams.append('limit', params.limit);
  if (params.licenceId) queryParams.append('licenceId', params.licenceId);
  
  const queryString = queryParams.toString();
  return apiFetch(`/api/admin/translation-requests${queryString ? `?${queryString}` : ''}`);
}

/**
 * Get translation request details (admin)
 */
export function getTranslationRequest(id) {
  return apiFetch(`/api/admin/translation-requests/${id}`);
}

/**
 * Update translation request (admin)
 */
export function updateTranslationRequest(id, data) {
  return apiFetch(`/api/admin/translation-requests/${id}`, {
    method: 'PATCH',
    body: data
  });
}
